import { render, staticRenderFns } from "./EditMainPage.vue?vue&type=template&id=273ebc78&"
import script from "./EditMainPage.vue?vue&type=script&lang=js&"
export * from "./EditMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports